export const makeSpace = <T extends number>(size: T): `${T}px` => {
  return `${size}px`;
};
